<div>
  <router-outlet></router-outlet>
</div>
<app-loader></app-loader>
